import {Feature} from "ol";
import {Point} from "ol/geom";
import {fromLonLat} from "ol/proj";
import {Fill, Stroke, Style, Text} from "ol/style";
import CircleStyle from "ol/style/Circle";
import {ratingColorList} from "@/components/MapPage/MainMap/constant";

const getCircleSize = (newsCount) => {
    if (newsCount === 1) return 10;
    if (newsCount < 10 ) return 16;
    if (newsCount > 9 && newsCount < 100) return 18;
    if (newsCount > 99 && newsCount < 1000) return 24;
    if (newsCount > 999) return 28;
};

export const initializeNews = (map, newsList) => {
    const layers = map.getLayers();
    let newsVectorSource;

    // Поиск слоя с регионами
    layers.forEach((layer) => {
        if (layer.getSource().get("name") === "news") newsVectorSource = layer.getSource();
    });

    newsVectorSource.clear();

    if (newsList === null) return false;
    let index = 0;
    for (let news of newsList) {
        index += 1;
        const feature = new Feature({
            geometry: new Point(
                fromLonLat([news.city.longitude, news.city.latitude])),
            type: "news",
            newsList: news.cardsIds,
            cityName: news.city.city
        });
        const cityCtyle = new Style({
            image: new CircleStyle({
                radius: getCircleSize(news.cardsIds.length),
                fill: new Fill({ color: ratingColorList[news.maxImportance] }), // Цвет заливки точки
                stroke: new Stroke({ color: "#ffffff", width: 2 }), // Обводка точки
            }),
            text: new Text({
                scale: 1.3,
                offsetY: 2,
                font: "14px Roboto,sans-serif",
                overflow: true,
                text: news.cardsIds.length === 1 ? "" : news.cardsIds.length + "",
                fill: new Fill({
                    color: "#ffffff"
                }),
            }),
            zIndex: index,
        });

        feature.setStyle(cityCtyle);

        newsVectorSource.addFeature(feature);

    }
};

// export const initializeNews = (map, newsList) => {
//     const layers = map.getLayers()
//     let newsVectorSource
//
//     // Поиск слоя с регионами
//     layers.forEach((layer) => {
//         if (layer.getSource().get('name') === 'news') newsVectorSource = layer.getSource()
//     })
//
//     newsVectorSource.clear();
//
//     if (newsList === null) return false
//
//     const groupedNewList = groupByCoordinates(newsList)
//
//     let index = 0
//     for (let [key, group] of groupedNewList) {
//         let coord = key.split(',')
//
//         index += 1
//         if (group.items.length > 0) {
//             const feature = new Feature({
//                 geometry: new Point(
//                     fromLonLat([coord[1], coord[0]])),
//                 type: 'news',
//                 newsList: group.items,
//             });
//             const cityCtyle = new Style({
//                 image: new CircleStyle({
//                     radius: getCircleSize(group.items.length),
//                     fill: new Fill({ color: ratingColorList[group.importance] }), // Цвет заливки точки
//                     stroke: new Stroke({ color: "#ffffff", width: 2 }), // Обводка точки
//                 }),
//                 text: new Text({
//                     scale: 1.3,
//                     offsetY: 2,
//                     font: '14px Roboto,sans-serif',
//                     overflow: true,
//                     text: group.items.length === 1 ? '' : group.items.length + '' ,
//                     fill: new Fill({
//                         color: '#ffffff'
//                     }),
//                 }),
//                 zIndex: index,
//             });
//
//             feature.setStyle(cityCtyle)
//
//             newsVectorSource.addFeature(feature)
//         }
//     }
// }
//
// /* Группировка точек по одинаковым координатам **/
// const groupByCoordinates = (data) => {
//     const grouped = {};
//
//     data.forEach(item => {
//         item.cities.forEach(cities => {
//             const coordKey = `${cities.latitude},${cities.longitude}`;
//             if (!grouped[coordKey]) {
//                 grouped[coordKey] = {items: [], importance: 0.0};
//             }
//             grouped[coordKey].items.push(item);
//             if (item.importance > grouped[coordKey].importance) grouped[coordKey].importance = item.importance
//         })
//     });
//
//     return Object.entries(grouped)
// }